import { createReducer } from '../../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';


const statisticListHandlers = {
    [constant.statisticList](state, action) {
        return action.payload;
    }
};
const agentsHandlers = {
    [constant.agents](state, action) {
        return action.payload;
    }
};
const areasHandlers = {
    [constant.areas](state, action) {
        return action.payload;
    }
};
const statisticTotalHandlers = {
    [constant.statisticTotal](state, action) {
        return action.payload;
    }
};

const loadingHandlers = {
    [constant.loading](state, action) {
        return { ...state, loading: action.payload };
    },
}

const searchHandlers = {
    [constant.search](state, action) {
        return { ...state, ...action.payload }
    }
};

export const loading = createReducer({ loading: false }, loadingHandlers);
export const statisticList = createReducer([], statisticListHandlers);
export const search = createReducer({showErrorData: '0'}, searchHandlers);
export const agents = createReducer([], agentsHandlers);
export const areas = createReducer([], areasHandlers);
export const statisticTotal = createReducer([], statisticTotalHandlers);

export const taskStatistic = combineReducers({
    loading,
    statisticList,
    search,
    agents,
    areas,
    statisticTotal,
})



// {
//     orders: [],
//     search :{
//     }
//
// }




// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/task-statistics/reducers.js